query ListTravelAuthorizationNotes($id: UUID!) {
  travelAuthorization(id: $id) {
    id
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        id
        _createdByUserName
        _createdDate
        noteComment
        isShared
        _isUpdatable
        _rowTimestamp
        _isDeletable
      }
    }
  }
}
